import { cn } from "../../libs/cn";
import { Collapsible as CollapsiblePrimitive } from "@kobalte/core/collapsible";
import { splitProps } from "solid-js";

export const Collapsible = CollapsiblePrimitive;

export const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

export const CollapsibleContent = (props) => {
	const [local, rest] = splitProps(props, ["class"]);

	return (
		<CollapsiblePrimitive.Content
			class={cn(
				"animate-collapsible-up data-[expanded]:animate-collapsible-down",
				local.class,
			)}
			{...rest}
		/>
	);
};
